import errorLogger, {
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';

import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import { getContext } from '@/context';

// What this miniapp publishes to the others — the onboarding miniapp reads it.
export interface ISharedState {
  freeQuotaSpent?: boolean;
}

const logWarning = (e: unknown) =>
  errorLogger.trigger(e as Error, BUGSNAG_STATUSES.WARN);

// sharedStorage is the only store other miniapps can read, and every miniapp
// shares one object in it — both levels are merged so neither their keys nor
// ours are dropped by a partial write.
export const updateSharedState = (patch: Partial<ISharedState>) => {
  try {
    const { sharedStorage } = getContext().general;
    const state = sharedStorage.getState();

    Promise.resolve(
      sharedStorage.dispatch({
        ...state,
        [MINIAPP_PACKAGE_ID]: { ...state?.[MINIAPP_PACKAGE_ID], ...patch },
      })
    ).catch(logWarning);
  } catch (e) {
    logWarning(e);
  }
};
